export default {
  path: '/sign',
  meta: {
    title: '每日签到',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/sign`),
}



// WEBPACK FOOTER //
// ./src/views/Sign/router.js